import './vehicle-search-form.scss';

const VehicleSearchFormSkeleton = () => (
    <div
        className="osb-v3-vehicle-search-container"
        data-testid="vehicle-search-form-skeleton"
    >
        <div
            className="vehicle-search-section-title"
            style={{
                backgroundColor: '#e2e2e2',
                height: '32px',
                width: '70%',
                borderRadius: '4px',
                color: 'transparent',
            }}
        ></div>

        <div
            className="vehicle-search-section-desc"
            style={{
                backgroundColor: '#e2e2e2',
                height: '20px',
                width: '90%',
                marginTop: '10px',
                borderRadius: '4px',
            }}
        ></div>

        <div className="vehicle-search-input-section">
            <div
                className="osb-v3-reg-num-or-vin-label"
                style={{
                    backgroundColor: '#e2e2e2',
                    height: '16px',
                    width: '40%',
                    borderRadius: '4px',
                }}
            ></div>
            <div
                className="osb-v3-reg-vin-input-wrapper"
                style={{
                    backgroundColor: '#e2e2e2',
                    height: '48px',
                    width: '100%',
                    marginTop: '8px',
                    borderRadius: '8px',
                }}
            ></div>
        </div>

        <div className="cta-control-section">
            <div
                className="continue-btn"
                style={{
                    backgroundColor: '#e2e2e2',
                    height: '48px',
                    borderRadius: '8px',
                }}
            ></div>
        </div>
    </div>
);

export default VehicleSearchFormSkeleton;
